export const systemConstants = {
    SET_SYSTEM_COUNTRY: 'SET_SYSTEM_COUNTRY',
    SET_SYSTEM_LANGUAGE: 'SET_SYSTEM_LANGUAGE'
};
